import React from 'react';
import clsx from 'clsx';

import Icon from '../../icons/Icon';
import { ICONS } from '../../icons';
import { AI_MEDIA_TYPES, PLAYGROUND_RESPONSE_TYPES } from '../../constants';
import UserIcon from './UserIcon';
import TextItem from './response-items/TextItem';
import ImageItem from './response-items/ImageItem';
import VideoItem from './response-items/VideoItem';

import scss from '../AiPlayground.module.scss';

function ResponseItem({ response }) {
  return (
    <li
      className={clsx(
        scss.messageWrapper,
        response.responseType === PLAYGROUND_RESPONSE_TYPES.USER ? scss.userMessage : scss.assistantMessage,
      )}>
      {response.responseType === PLAYGROUND_RESPONSE_TYPES.USER ? (
        <UserIcon />
      ) : (
        <Icon icon={ICONS.Logo} disableCommonStyles className={scss.messageIcon} />
      )}
      <span className={scss.messageContainer}>
        {!response.isMedia && <TextItem message={response.message} />}
        {response.isMedia && response.mediaType === AI_MEDIA_TYPES.IMAGE && <ImageItem mediaId={response.mediaId} />}
        {response.isMedia && response.mediaType === AI_MEDIA_TYPES.VIDEO && <VideoItem mediaId={response.mediaId} />}
      </span>
    </li>
  );
}

export default ResponseItem;
